<template>
  <v-app>
    <v-main>
      <ImagesViewer />
      <v-container class="mt-6 text-center">
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg1') }}</h1>
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg2') }}</h1>
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg3') }}</h1>
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg4') }}</h1>
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg5') }}</h1>
        <h1 class="text-h5 mb-4">{{ $t('bookingConfirmation.msg6') }}</h1>
        <v-row justify="center" class="mt-4">
                <v-col cols="auto">
                  <v-img
                    src="images/whatsapp2.png"
                    height="80px"
                    width="80px"
                    class="cursor-pointer"
                    @click="gowhatsappToLink"
                  ></v-img>
                </v-col>
                </v-row>
        <!-- <v-icon size="48" color="primary">mdi-check-circle-outline</v-icon> -->

        <!-- Show the server's message, if any -->
        

        <!-- Also display name, phone, price if you want -->
        <p class="mt-4" v-if="name && phone && totalPrice">

          {{ $t('bookingForm.fullName') }} {{ name }} <br/> {{ $t('bookingForm.phone') }} {{ phone }}<br/>
          {{ $t('bookingForm.totalPrice') }} {{ totalPrice }} {{ $t('bookingForm.currency') }}
        </p>

        <v-btn class="mt-4" color="primary" @click="$router.push('/')">
          {{ $t('bookingForm.homepage') }}
        </v-btn>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import ImagesViewer from '@/components/ImagesViewer.vue';

export default {
  components: { ImagesViewer },
  data() {
    return {
      name: this.$route.query.name || '',
      phone: this.$route.query.phone || '',
      totalPrice: this.$route.query.total_price || '',
      numofdays: this.$route.query.numofdays || '',
      // NEW: display server's custom message
      message: this.$route.query.message || 'Thank you for booking.'
    }
  },
  methods: {
    gowhatsappToLink() {
      window.open('https://wa.me/96894648300', '_blank');
    },
  }
}
</script>

<style scoped>
</style>
